import { useEffect, useState } from "react";
import Gallery from "../../../Gallery";
import VehicleStatusBasicInfo from "./VehicleStatusBasicInfo";
import VehicleStatusDriverInfo from "./VehicleStatusDriverInfo";
import VehicleStatusVehicleInfo from "./VehicleStatusVehicleInfo";
import { GrUserManager } from "react-icons/gr";
import { FiTruck } from "react-icons/fi";
import VehicleStatusInfo from "./VehicleStatusInfo";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdOutlineBusinessCenter } from "react-icons/md";
import { fetchDataById } from "../../../../api/requestCreation";
import {
  getOtherRefDetails,
  getTextByValueAndKey,
} from "../../../../api/keyvalue";
import MapComponent from "../../../maps/MapComponent";
import { MAP_TYPES } from "../../../../const";
import { vehicleById } from "../../../../api/vehicleapi";
import { getLocation } from "../../../../api/locationCreationApi";
import { useSelector } from "react-redux";

const JobVehicleStatus = ({
  jobId,
  requestId,
  jobCode,
  vehicleId,
  driverId,
  trackingEnabled,
  wsConnection,
  timeUpdateCompleted,
  lastDepartureTime,
  firstArrivalTime,
  vehicleInfoOnly = false,
  isHideTabs = false,
}) => {
  const userData = useSelector((state) => state.user.userDetails);
  const isExternalUser = userData.type === 2 || userData.type === 3;
  const [isLoading, setIsLoading] = useState(false);
  const [locationDetails, setLocationDetails] = useState([]);
  const [activeTab, setActiveTab] = useState(
    vehicleInfoOnly ? "vehicle" : !isExternalUser ? "status" : "job"
  );
  const [requestData, setRequestData] = useState({});
  const [startLocation, setStartLocation] = useState("");
  const [endLocation, setEndLocation] = useState("");
  const [vehicleData, setVehicleData] = useState({});
  const [vehicleFeatures, setVehicleFeatures] = useState([]);
  const [startLat, setStartLat] = useState(0);
  const [startLng, setStartLng] = useState(0);
  const [endLat, setEndLat] = useState(0);
  const [endLng, setEndLng] = useState(0);
  const [terminalId, setTerminalId] = useState(null);
  const [viaLocations, setViaLocations] = useState([]);

  useEffect(() => {
    (async () => {
      if (!vehicleInfoOnly) {
        setIsLoading(true);
        const requestData = await fetchDataById(requestId);
        setRequestData(requestData);
        const locations = [];
        const via = [];
        for (let location of requestData.requestLocationsResponses) {
          const locationResponse = await getOtherRefDetails({
            type: "location_customer",
            value: requestData.reqLCustomerId.toString(),
            param2: location.rlkLocation.toString(),
          });
          const locationDetails =
            locationResponse && locationResponse.length > 0
              ? locationResponse[0]
              : {};
          const locationId = locationDetails.retActive;
          const locationName = locationDetails.retField1;
          const lon = location.rlkLon;
          const lat = location.rlkLat;
          const locationFullResponse = await getLocation(locationId);
          let geoFenceData = {};
          if (
            locationFullResponse &&
            locationFullResponse.locationGpsLocations &&
            locationFullResponse.locationGpsLocations.length > 0
          ) {
            geoFenceData = locationFullResponse.locationGpsLocations.reduce(
              (acc, obj) => {
                let key = obj.lgpGpsProviderId;
                acc[key] = obj.lgpGeoFenceCords;
                return acc;
              },
              {}
            );
          }
          if (location.rlkLocationType === 1) {
            setStartLat(lat);
            setStartLng(lon);
            setStartLocation(locationName);
            locations.push({
              locationName: locationName,
              locationId: locationId,
              lon,
              lat,
              type: 1,
              seq: location.rlkSeq,
              geoFenceData,
            });
          } else if (location.rlkLocationType === 2) {
            setEndLat(lat);
            setEndLng(lon);
            setEndLocation(locationName);
            locations.push({
              locationName: locationName,
              locationId: locationId,
              lon,
              lat,
              type: 2,
              seq: location.rlkSeq,
              geoFenceData,
            });
          } else {
            locations.push({
              locationName: locationName,
              locationId: locationId,
              lon,
              lat,
              type: 3,
              seq: location.rlkSeq,
              geoFenceData,
            });
            via.push({
              locationName: locationName,
              locationId: locationId,
              lon,
              lat,
              type: 3,
              seq: location.rlkSeq,
              geoFenceData,
            });
          }
        }
        setIsLoading(false);
        setLocationDetails(locations);
        setViaLocations(via);
      }
    })();
  }, [jobId, requestId]);

  useEffect(() => {
    (async () => {
      if (vehicleId) {
        setIsLoading(true);
        const vehicle = await vehicleById(vehicleId);
        setVehicleFeatures(vehicle.vehicleDetail.vehicleFeatures);
        let fuelTypeValue = "";
        if (vehicle?.vehicleDetail?.vehFuelType) {
          fuelTypeValue = await getTextByValueAndKey(
            "fuel_type",
            vehicle?.vehicleDetail?.vehFuelType
          );
        }
        setTerminalId(vehicle?.vehicleDetail?.vehGpsReference);
        setVehicleData({
          ...vehicle.vehicleDetail,
          vehFuelType: fuelTypeValue,
        });

        setIsLoading(false);
      }
    })();
  }, [vehicleId]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="popup">
      {!isHideTabs && (
        <div className="pop-tab">
          <div className="ui top attached tabular menu">
            {!isExternalUser && !vehicleInfoOnly && (
              <div
                className={`item tab-set ${activeTab === "status" ? "active" : ""}`}
                onClick={() => handleTabClick("status")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <IoMdCheckmarkCircleOutline
                  size={15}
                  style={{ marginRight: "6px" }}
                />
                <span>
                  <h5>Status</h5>
                </span>
              </div>
            )}
            {!vehicleInfoOnly && (
              <div
                className={`item tab-set ${activeTab === "job" ? "active" : ""}`}
                onClick={() => handleTabClick("job")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <MdOutlineBusinessCenter
                  size={15}
                  style={{ marginRight: "6px" }}
                />
                <span>
                  <h5>Job</h5>
                </span>
              </div>
            )}

            {driverId && (
              <div
                className={`item ${activeTab === "driver" ? "active" : ""}`}
                onClick={() => handleTabClick("driver")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <GrUserManager size={15} style={{ marginRight: "6px" }} />
                <span>
                  <h5>Driver</h5>
                </span>
              </div>
            )}
            {vehicleId && (
              <div
                className={`item ${activeTab === "vehicle" ? "active" : ""}`}
                onClick={() => handleTabClick("vehicle")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <FiTruck size={15} style={{ marginRight: "6px" }} />
                <span>
                  <h5>Vehicle</h5>
                </span>
              </div>
            )}
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ height: "74vh" }}
          >
            {!vehicleInfoOnly && (
              <VehicleStatusBasicInfo
                jobId={jobId}
                requestId={requestId}
                jobCode={jobCode}
                requestData={requestData}
                startLocation={startLocation}
                endLocation={endLocation}
                isLoading={isLoading}
                activeTab={activeTab}
              />
            )}
            {!vehicleInfoOnly && (
              <VehicleStatusInfo
                jobId={jobId}
                requestId={requestId}
                activeTab={activeTab}
              />
            )}
            {driverId && (
              <VehicleStatusDriverInfo
                driverId={driverId}
                activeTab={activeTab}
              />
            )}
            {vehicleId && (
              <VehicleStatusVehicleInfo
                vehicleData={vehicleData}
                vehicleFeatures={vehicleFeatures}
                activeTab={activeTab}
                isLoading={isLoading}
              />
            )}
          </div>
        </div>
      )}
      <div className="pop-map">
        <Gallery
          activeTab={activeTab}
          driverId={driverId}
          vehicleId={vehicleId}
        />
        {trackingEnabled ? (
          <MapComponent
            wsConnection={wsConnection}
            requestStartDate={requestData.reqApprovedDate}
            activeTab={activeTab}
            type={MAP_TYPES.LIVE}
            terminalId={terminalId}
            vehicleId={vehicleId}
            locations={locationDetails}
            vehicleDetails={vehicleData}
            timeUpdateCompleted={false}
            lastDepartureTime={null}
            firstArrivalTime={null}
          />
        ) : (
          <>
            {timeUpdateCompleted && !!terminalId ? (
              <MapComponent
                wsConnection={wsConnection}
                requestStartDate={requestData.reqApprovedDate}
                activeTab={activeTab}
                type={MAP_TYPES.LIVE}
                terminalId={terminalId}
                vehicleId={vehicleId}
                locations={locationDetails}
                vehicleDetails={vehicleData}
                timeUpdateCompleted={true}
                lastDepartureTime={lastDepartureTime}
                firstArrivalTime={firstArrivalTime}
              />
            ) : (
              <MapComponent
                activeTab={activeTab}
                type={MAP_TYPES.STATIC}
                initialLocations={[
                  { lat: parseFloat(startLat), lng: parseFloat(startLng) },
                  ...viaLocations.map((location) => ({
                    lat: parseFloat(location.lat),
                    lng: parseFloat(location.lon),
                  })),
                  { lat: parseFloat(endLat), lng: parseFloat(endLng) },
                ]}
                showDirections={true}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default JobVehicleStatus;
